import { render, staticRenderFns } from "./RemovePartnerModal.vue?vue&type=template&id=28333291"
import script from "./RemovePartnerModal.vue?vue&type=script&lang=js"
export * from "./RemovePartnerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports